import * as React from 'react';
import { Flex } from '@qga/roo-ui/components';

import GlobalHeader from 'components/GlobalHeader';
import GlobalFooter from 'components/GlobalFooter';
import { useRouteMatch } from 'react-router';

const GlobalLayout: React.FC = ({ children }) => {
  const printPageMatch = useRouteMatch('/bookings/:bookingId/print');

  if (printPageMatch) {
    return <>{children}</>;
  }

  return (
    <Flex flexDirection="column" minHeight="100vh">
      <Flex flex="1 0 auto" flexDirection="column" width="100%" bg="greys.porcelain">
        <GlobalHeader />
        <Flex id="content" flex="1 0 auto" flexDirection="column">
          {children}
        </Flex>
      </Flex>
      <GlobalFooter />
    </Flex>
  );
};

export default GlobalLayout;
